import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../utils/store/actions/userInfoAction";
import { setTimeTable } from "../utils/store/actions/timeTableAction";
import { useRouter } from "next/router";
import { setCookie } from "nookies";
import { phoneFomatter, timerFomatter } from "../utils/common/fomatter";
import { SEND_PHONE_NUM, LOGIN, CONFIRM } from "../utils/fetch/apiConfig";
import FAQ from "../components/FAQ/FAQ";
import Exit from "../components/Exit/Exit";
import axios from "axios";
import Logo from "../components/Logo/Logo";
import useTimer from "../utils/customHook/useTimer";
import ModalCommon from "../components/Modal/ModalCommon/ModalCommon";
import styles from "./index.module.scss";
import {
  setCheck,
  setIsCheckInit,
} from "../utils/store/actions/userStateAction";
import { setTimer } from "../utils/store/actions/timerActions";
import { setMediaStreamInit } from "../utils/store/actions/mediaStreamAction";

const errorMsg = "관리자에게 문의하세요.";

const Index = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [sendedInfo, setSendedInfo] = useState(false);
  const [time, setTime, timeStart, timeStop] = useTimer();
  const [input, setInput] = useState("");
  const [comment, setComment] = useState("");
  const [policyOpen, setPolicyOpen] = useState(false);
  const isLoading = useRef(false);

  useEffect(() => {
    // 응시자 정보 및 타임테이블, 타이머, 캠 정보 초기화
    dispatch(setUserInfo({}));
    dispatch(
      setTimer({
        startTime: "2021-01-25 10:00",
        afterTime: 0,
        timeLimit: 7200,
        start: () => {},
        stop: () => {},
      })
    );
    dispatch(setTimeTable([]));
    dispatch(setIsCheckInit());
    dispatch(setMediaStreamInit());
  }, []);

  const checkLoginState = (res) =>
    res.data.result === "preCheckTest" ||
    res.data.result === "firstTest" ||
    res.data.result === "secondTest";

  const sendAuthNum = async () => {
    if (isLoading.current) {
      return;
    }

    try {
      isLoading.current = true;

      const res = await axios.post(LOGIN, {
        phoneNum: sendedInfo,
        confirmNo: input,
      });

      if (checkLoginState(res)) {
        dispatch(setUserInfo(res.data.Tester));
        sessionStorage.setItem("userInfo", JSON.stringify(res.data.Tester));
        dispatch(setTimeTable(res.data.TimeTable));
        sessionStorage.setItem("timeTable", JSON.stringify(res.data.TimeTable));

        axios.defaults.headers.common["token"] = res.data.token;

        setCookie(null, "token", res.data.token, {
          path: "/",
          maxAge: 99999,
        });

        isLoading.current = false;

        if (res.data.result === "preCheckTest") {
          if (res.data.Tester.TESTER_WHICH === "Y") {
            router.push("/device?mod=test");
          } else {
            router.push("/prevInfo");
          }
        } else if (res.data.result === "firstTest") {
          router.push("/device");
        } else if (res.data.result === "secondTest") {
          router.push("/device?mod=secondTest");
        }
      } else {
        isLoading.current = false;
        setComment(res.data.msg);
      }
    } catch (error) {
      isLoading.current = false;
      setComment(errorMsg);
      console.error(error);
    }
  };

  const sendPhoneNum = async () => {
    if (isLoading.current) {
      return;
    }

    try {
      isLoading.current = true;

      const res = await axios.post(SEND_PHONE_NUM, {
        phoneNum: input,
      });

      if (checkLoginState(res)) {
        setSendedInfo(input);
        setComment("");
        setInput("");
        timeStart();
        isLoading.current = false;
      } else {
        isLoading.current = false;
        setComment(res.data.msg);
      }
    } catch (error) {
      isLoading.current = false;
      setComment(errorMsg);
      console.error(error);
    }
  };

  const sendInput = (e) => {
    e.preventDefault();

    if (sendedInfo) {
      sendAuthNum();
    } else {
      sendPhoneNum();
    }
  };

  useEffect(() => {
    if (time === 0) {
      setInput("");
      setSendedInfo(false);
      timeStop(true);
    }
  }, [time]);

  return (
    <div className={styles.wrap}>
      <video muted autoPlay loop playsInline>
        <source src="/img/lotte_login_bg.webm" type="video/webm" />
      </video>
      <Logo style={{ position: "fixed", top: 27, left: 32 }} />

      <div className={styles.login_wrap}>
        <div className={styles.title}>
          {router.query.c === "ac" ? "VAC" : "L-TAB"}
        </div>
        <form>
          <div className={styles.input_wrap}>
            <input
              placeholder={sendedInfo ? "인증 번호 입력" : "휴대전화 번호 입력"}
              maxLength={sendedInfo ? 6 : 13}
              value={sendedInfo ? input : phoneFomatter(input)}
              onChange={(e) => setInput(e.target.value.replace(/[^0-9]/g, ""))}
            />
            {sendedInfo && (
              <div className={styles.timer}>
                <i className="xi-time-o" />
                {timerFomatter(time)}
              </div>
            )}
          </div>
          <button onClick={(e) => sendInput(e)}>
            {sendedInfo ? "로그인" : "인증번호 발송"}
          </button>
        </form>

        {comment && (
          <div className={styles.comment}>
            <i className="xi-info" />
            {comment}
          </div>
        )}
        <div className={styles.hotspot}>
          {`사전 점검 및 본 진단 시, 휴대전화 통한 핫스팟 사용 금지`}
        </div>
      </div>

      <FAQ fixed top={25} right={100} />
      <Exit fixed top={21} right={30} />
    </div>
  );
};

export default Index;
